import Cookies from "js-cookie";
$.ajaxSetup({
  headers: { "Token": Cookies.get("vp_jwt_auth") }
});
